import { cn, createBEM } from "@/libs";
import { ComponentBase } from "@/types";
import { NavLink } from "react-router-dom";
import { Icon, IconName } from "../Icon";
import {SafeArea} from 'antd-mobile';
import "./index.scss";
import { ScanPopup } from "../ScanPopup";

export interface TabBarProps extends ComponentBase.Component {}
export const TabBar = ({ className, ...rest }: TabBarProps) => {
  const b = createBEM("i-tab-bar");
  const items = [
    {
      to: "/root/home",
      icon: "root-home",
      label: '首页'
    },
    {
      to: "/root/trade",
      icon: "root-trade",
      label: '挂单'
    },
    {
      to: "",
      icon: "empty",
      label:  
        <ScanPopup>
          <div className={
            cn(b("scan"))
          }>
            <div
              className={
                cn(b("scan_icon"))
              }
            ></div>
          </div>
        </ScanPopup>
    },
    {
      to: "/root/orders?type=normal",
      icon: "root-orders",
      label: '订单'
    },
    {
      to: "/root/user",
      icon: "root-user",
      label: '我的'
    },
  ];

  return (
    <div className={cn(b())}>
      <div className={cn(b('content'))}>
      {items.map((item) => {
        return (
          item.to ? <NavLink
            className={({ isActive }) => {
              return cn(
                b("item", {
                  active: isActive,
                })
              );
            }}
            to={item.to}
            key={item.icon}
            replace
          >
            {({ isActive }) => {
              return (
                <>
                  <Icon
                    name={
                      cn(b("icon", { active: isActive }), item.icon, {
                        active: isActive,
                      }) as IconName
                    }
                    size={"24px"}
                  />
                  <div className={cn(b('item_text'))}>{item.label}</div>
                </>
              );
            }}
          </NavLink> : <div key={item.icon}
            className={cn(b("item"))}
          >{item.label}</div>
        );
      })}
      </div>
      
      <SafeArea position="bottom"/>
    </div>
  );
};
